import { motion } from 'framer-motion';
import { Scales, Building, Envelope, Globe, FileText } from '@phosphor-icons/react';

export default function LegalMentions() {
  return (
    <div className="pt-20" data-testid="legal-mentions-page">
      <section className="py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-3">Informations légales</p>
            <h1 className="font-heading text-3xl sm:text-4xl text-white mb-8">Mentions légales</h1>
            <p className="text-sm text-desti-text mb-8">Dernière mise à jour : 13 mai 2026</p>
          </motion.div>

          <div className="space-y-8 text-desti-text">
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="border-l-2 border-desti-gold pl-5"
            >
              <div className="flex items-center gap-2 mb-2">
                <Building size={20} weight="duotone" className="text-desti-gold" />
                <h2 className="font-heading text-xl text-white">Éditeur du site</h2>
              </div>
              <p className="leading-relaxed">
                Le site <strong className="text-white">destidriving.fr</strong> est édité par  <strong className="text-white">Jovenel</strong>, Destina.<br />
                <strong>Siège social :</strong> Rue de l'église, Ablon sur seine<br />
                <strong>Capital social :</strong> 16 610,00 € <br />
                <strong>SIRET :</strong> 942 572 389 00016 – <strong>RCS :</strong> 942 572 389 Creteil<br />
                <strong>Directeur de la publication :</strong> Jovenel Destina, Président
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="border-l-2 border-desti-gold pl-5"
            >
              <div className="flex items-center gap-2 mb-2">
                <Globe size={20} weight="duotone" className="text-desti-gold" />
                <h2 className="font-heading text-xl text-white">Hébergement</h2>
              </div>
              <p className="leading-relaxed">
                Le site est hébergé par <strong className="text-white">[IONOS SARL]</strong>.<br />
                Adresse : [7, place de la Gare 
                                    57200 Sarreguemines Cedex, France]
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="border-l-2 border-desti-gold pl-5"
            >
              <div className="flex items-center gap-2 mb-2">
                <FileText size={20} weight="duotone" className="text-desti-gold" />
                <h2 className="font-heading text-xl text-white">Propriété intellectuelle</h2>
              </div>
              <p className="leading-relaxed">
                Tous les éléments du site (textes, images, logo, graphismes) sont protégés par le droit d’auteur et restent la propriété exclusive de PARIS VTC. Toute reproduction est interdite sans autorisation préalable.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="border-l-2 border-desti-gold pl-5"
            >
              <div className="flex items-center gap-2 mb-2">
                <Envelope size={20} weight="duotone" className="text-desti-gold" />
                <h2 className="font-heading text-xl text-white">Contact</h2>
              </div>
              <p className="leading-relaxed">
                Pour toute question : <a href="mailto:contact@destidriving.fr" className="text-desti-gold hover:underline">contact@destidriving.fr</a>
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}